import { RecentSearchItem } from "@/src/common/types"
import RecycleIcon from "@/src/sb/components/icon/RecycleIcon"
import X from "@/src/sb/components/icon/X"
import React, { Fragment } from "react"

type RecentResearchProps = {
  recentSearches: RecentSearchItem[]
  onClickSearch?: (search: RecentSearchItem) => void
  onRemoveSearch: (search: RecentSearchItem) => void
}

const RecentResearch = ({
  recentSearches,
  onClickSearch,
  onRemoveSearch
}: RecentResearchProps) => {
  return (
    <Fragment>
      <h3 className="text-gray-400 text-[10px] px-5 py-2.5">Recent Searches</h3>
      {recentSearches.map((item, idx) => (
        <li
          key={idx}
          onClick={() => onClickSearch?.(item)}
          className="py-2.5 px-5 flex items-center justify-between hover:bg-[#1A1D21] cursor-pointer group"
        >
          <div className="flex items-center gap-2">
            <span className="dark:text-white">
              <RecycleIcon />
            </span>
            <span className="text-xs font-[400]">{item.name}</span>
          </div>

          <button
            onClick={(e) => {
              e.stopPropagation()
              onRemoveSearch(item)
            }}
            className="text-gray-400 text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-200"
          >
            <X />
          </button>
        </li>
      ))}
    </Fragment>
  )
}

export default RecentResearch
